<template lang="pug">
  .fullscreenrror(v-if='axiosErrorExists || isWebsocketError' id="Error-fullscreen")
    h3.centered Error {{ this.$store.state.Error.axios_error.status }} - {{ this.$store.state.Error.axios_error.statusText }}
    error400(v-if="isError(400) && !isAssignError", @ackError='ackError')
    error403(v-if="isError(403)", @ackError='ackError')
    error404(v-if="isError(404)", @ackError='ackError')
    error406(v-if="isError(406)", @ackError='ackError')
    error500(v-if="isError(500)", @ackError='ackError')
    errorAssign(v-if="isAssignError", @ackError='ackError')
    errorWebsocket(v-if="isWebsocketError")
</template>
<script>

import error400 from './error400'
import error403 from './error403'
import error404 from './error404'
import error406 from './error406'
import error500 from './error500'
import errorWebsocket from './errorWebsocket'
import errorAssign from './errorAssign'

export default {
  components: {
    error400,
    error403,
    error404,
    error406,
    error500,
    errorWebsocket,
    errorAssign
  },
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    ackError () {
      this.$store.dispatch('Error/deleteAxiosError')
    },
    isError (code) {
      return this.$store.state.Error.axios_error.status === code
    }
  },
  computed: {
    axiosErrorExists () {
      if (!this.$store.state.Error.axios_error) return false
      return Object.keys(this.$store.state.Error.axios_error).length !== 0
    },
    isWebsocketError () {
      return this.$store.state.Error.ws_status.status !== 200
    },
    isAssignError () {
      if (
        !this.$store.state.Error.axios_error ||
        !this.$store.state.Error.axios_error.config ||
        !this.$store.state.Error.axios_error.config.url
      ) {
        return false
      }
      return this.$store.state.Error.axios_error.config.url.indexOf('assignMediumToPlaylist') > -1
    },
    isUnknowsError () {
      return this.axiosErrorExists && ![400, 403, 404, 406, 500].includes(this.$store.state.Error.axios_error.status) && !this.isWebsocketError() && !this.isAssignError()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .fullscreenrror {
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height: 100%;
    z-index: 10000000;
    background-color: $--page-background;
    font-size: 150%;
  }
  .centered {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Error/error.vue